export const VERIFY_GOLD_CARD_ADDRESS = "VERIFY_GOLD_CARD_ADDRESS"
